<div
  class="registration-card d-flex flex-column"
  [class.wallet-box-wrap]="isCargoWallet"
>
  <h3
    class="mb-4"
    i18n="@@registration.manual.text-request-received"
    [class.wallet-blue]="isCargoWallet"
    [class.mx-1]="isCargoWallet"
  >
    We have received your request !
  </h3>
  <img
    class="d-block ml-auto me-auto"
    src="/assets/animation/manual-success.gif"
    alt="manual-success-animation"
    width="170px"
    height="170px"
    loading="lazy"
  />
  <h6
    class="mt-4 mb-3"
    i18n="@@registration.manual.text-confirmation-email"
    [class.wallet-black]="isCargoWallet"
  >
    Your confirmation email with logIn instructions will be sent within 24h.
  </h6>
  <button
    class="me-auto ml-auto"
    (click)="onNext.emit()"
    [class.wallet-blue-bg]="isCargoWallet"
  >
    OK
  </button>
  <div class="mt-4">
    <a href="/">
      <div
        class="signup-logo mt-4"
        [class.wallet-logo]="isCargoWallet"
        [ngStyle]="{
          'background-image': 'url(' + backgroundImage + ')',
        }"
      ></div>
    </a>
  </div>
</div>
